import { calculateAge } from 'lib/helpers/utility';

export const patientMapper = (itemProps = {}) => {
  const patient = itemProps?.patient;

  return {
    patient_id: patient?.id,
    patient_f_name: patient?.f_name,
    patient_l_name: patient?.l_name,
    patient_age: calculateAge({ dateOfBirth: patient?.dob })
  };
};
